import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { BOOKING_ENABLED } from '../../lib/bookingFlags';

/**
 * Wraps the /booking/* route tree. While BOOKING_ENABLED is false (see
 * lib/bookingFlags.ts), this blocks direct/typed-URL access to booking
 * pages — e.g. someone guessing or bookmarking
 * /booking/gst-registration?planId=plan_gst_basic — even though no
 * visible CTA links there anymore. Redirects to /consult, which is the
 * one path the client wants visitors funneled through right now.
 *
 * Deliberately a client-side redirect, not a route removal: the booking
 * pages, API routes, and Razorpay order-flow code are all left fully
 * intact underneath this guard so re-enabling later is a one-line flag
 * flip, not a rebuild.
 */
export function BookingGuard({ children }: { children: ReactNode }) {
  if (!BOOKING_ENABLED) return <Navigate to="/consult" replace />;
  return <>{children}</>;
}
